module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-active-shine-32.cbed9779.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-active-shine-32.png
// module id = 3177
// module chunks = 11